// DO NOT EDIT, GENERATED BY "yarn sheets"

import type { SizeRow } from '../typings';

const data = [
  {
    "id": "junior",
    "name": "Junior",
    "description": "6½-7⅛",
    "subset": {
      "modelId": {
        "ProMax": false,
        "Z5": true,
        "ALPHA": false,
        "GHOST": false,
        "ProX": false
      }
    }
  },
  {
    "id": "senior",
    "name": "Senior",
    "description": "7⅛-7½",
    "subset": {
      "modelId": {
        "ProMax": false,
        "Z5": true,
        "ALPHA": false,
        "GHOST": false,
        "ProX": false
      }
    }
  },
  {
    "id": "tball",
    "name": "T-Ball/S",
    "description": "6¼-6⅞",
    "subset": {
      "modelId": {
        "ProMax": false,
        "Z5": false,
        "ALPHA": true,
        "GHOST": false,
        "ProX": false
      }
    }
  },
  {
    "id": "small",
    "name": "S",
    "description": "6¼-6⅞",
    "subset": {
      "modelId": {
        "ProMax": false,
        "Z5": false,
        "ALPHA": false,
        "GHOST": true,
        "ProX": false
      }
    }
  },
  {
    "id": "medium",
    "name": "M/L",
    "description": "6⅝-7¼",
    "subset": {
      "modelId": {
        "ProMax": true,
        "Z5": false,
        "ALPHA": true,
        "GHOST": true,
        "ProX": false
      }
    }
  },
  {
    "id": "large",
    "name": "L/XL",
    "description": "7⅛-7¾",
    "subset": {
      "modelId": {
        "ProMax": true,
        "Z5": false,
        "ALPHA": true,
        "GHOST": true,
        "ProX": false
      }
    }
  },
  {
    "id": "xLarge",
    "name": "XL",
    "description": "7½-8",
    "subset": {
      "modelId": {
        "ProMax": false,
        "Z5": true,
        "ALPHA": false,
        "GHOST": false,
        "ProX": false
      }
    }
  },
  {
    "id": "proxSmall",
    "name": "S/M",
    "description": "6⅝-7¼",
    "subset": {
      "modelId": {
        "ProMax": false,
        "Z5": false,
        "ALPHA": false,
        "GHOST": false,
        "ProX": true
      }
    }
  },
  {
    "id": "proxLarge",
    "name": "L/XL",
    "description": "7¼-7⅝",
    "subset": {
      "modelId": {
        "ProMax": false,
        "Z5": false,
        "ALPHA": false,
        "GHOST": false,
        "ProX": true
      }
    }
  }
] as const;

type Primitive = string | number | boolean | null | undefined;
type Immutable<T> = T extends Primitive
  ? T
  : { readonly [K in keyof T]: Immutable<T[K]> };

type Combine<T extends U, U> = T extends Readonly<Primitive | Primitive[]>
  ? T
  : T extends ReadonlyArray<infer I>
  ? Readonly<Combine<I, Extract<U, Readonly<any[]>>[number]>[]>
  : U extends Readonly<Primitive | any[]>
  ? never
  : string extends keyof U
  ? { [K in keyof T & string]: Combine<T[K], U[K]> }
  : number extends keyof U
  ? { [K in keyof T & number]: Combine<T[K], U[K]> }
  : symbol extends keyof U
  ? { [K in keyof T & symbol]: Combine<T[K], U[K]> }
  : { [K in keyof U]: Combine<T[K], U[K]> };

const typed: Combine<typeof data, Immutable<SizeRow[]>> = data;

export type Size = typeof typed[number];

export const SIZE_INDEX_KEY = "id";
export type SizeIndexKey = "id";
export type SizeId = Size["id"];

let i = 0;
export const SIZE_DICT = {
  "junior": typed[i++],
  "senior": typed[i++],
  "tball": typed[i++],
  "small": typed[i++],
  "medium": typed[i++],
  "large": typed[i++],
  "xLarge": typed[i++],
  "proxSmall": typed[i++],
  "proxLarge": typed[i++]
} as const;

export { typed as SIZES };
